export enum MaskType {
  alphanumeric
}

const MaskTypeRegex = { [MaskType.alphanumeric]: /[A-Za-z0-9]/g }

export function maskText(text: string, find: MaskType, replace = '*') {
  return text.replace(MaskTypeRegex[find], replace)
}
